import React, { useState, useContext, useEffect } from 'react';

import { Form, Button, Input, Checkbox, List } from 'semantic-ui-react'
import GlobalContext from '../../../contexts/GlobalContext';
import { SET_USER } from '../../../contexts/GlobalType';
import API, { ResponseManagement, ErrorManagement } from '../../../API';
// import Auth from '../../Auth';
import Utility from '../../../Utility';
import { toast } from 'react-toastify';
import ModalAccount from '../ModalAccount/ModalAccount';
import ModalTransition from '../../ModalTransition/ModalTransition';
import 'react-toastify/dist/ReactToastify.css';
import './FormConnectionAndSetting.css';

const FormConnectionAndSetting = (props) => {
  const [globalContext, dispatch] = useContext(GlobalContext);
  const [showModalRgpd, setShowModalRgpd] = useState(false);
  const [showModalState, setShowModalState] = useState(false);
  const [gdprAgreementState, setGdprAgreementState] = useState(false);
  //const [mailingState, setMailingState] = useState(false);
  const [dataLoadState, setDataLoadState] = useState(false);

  useEffect(() => {
    if (globalContext.user && Object.entries(globalContext.user).length > 0) {
      setGdprAgreementState(globalContext.user.gdprAgreement);
      //setMailingState(globalContext.user.mailing);
      setDataLoadState(true);
    }
  }, [globalContext.user]);

  /**
   * Evenet Submit form
   * @param Object event
   */
  const handleSubmit = async (event) => {
    let errorDetect = false,
      data = Object.assign({}, globalContext.user);

    data.gdprAgreement = gdprAgreementState;
    //data.mailing = mailingState;
    if (errorDetect === false) {
      //data = new URLSearchParams(data);
      API.postForm(Utility.getUrlAjax() + '/updateUserAction', data)
        .then(response => {
          ResponseManagement(response,
            () => {
              setGdprAgreementState(response.data.data.user.gdprAgreement);
              //setMailingState(response.data.data.user.mailing);
              dispatch({ type: SET_USER, payload: response.data.data.user });
              props.handleChangePage('personalInformation', 'after');
              if (response.data.message) {
                toast.success(response.data.message);
              }
            },
            () => {
              setDataLoadState(false);
              toast.error(response.data.message);
            }
          );
        })
        .catch(error => {
          console.error("error",error)
          ErrorManagement(error, () => { });
        })
    } else {
      toast.error(globalContext.translations.msgErrorEnterAllInput);
    }
  }

  const handleClickOpenModal = (typeModal) => {
    let listModal = Object.assign({}, showModalState);
    listModal[typeModal] = true;
    setShowModalState(listModal)
  }

  const handleCloseModal = (typeModal) => {
    let timeOutCloseModal = setTimeout(() => {
      let listModal = Object.assign({}, showModalState);
      listModal[typeModal] = false;
      setShowModalState(listModal);
      window.clearTimeout(timeOutCloseModal);
    }, 500);
  }

  const handleClickActionModal = async (typeModal, dataForm) => {
    if (typeModal === 'changeEmail') {
      dataForm.append('newMail', dataForm.get('input_email'));
      dataForm.append('password', dataForm.get('input_password'));
      dataForm.delete('input_email');
      dataForm.delete('input_password');

      dataForm = new URLSearchParams(dataForm);
      API
        .post(Utility.getUrlAjax() + '/updateMailUserAction', dataForm)
        .then(response => {
          ResponseManagement(response,
            () => {
              dispatch({ type: SET_USER, payload: response.data.data.user });
              toast.success(response.data.message);
              setShowModalState(false);
            },
            () => {toast.error(response.data.message); }
          );
        })
        .catch(error => {
          console.error(error)
          ErrorManagement(error, () => { });
        });
    } else {
      dataForm.append('password', dataForm.get('input_password'));
      dataForm.append('newPassword', dataForm.get('input_newPassword'));
      dataForm.append('confirmPassword', dataForm.get('input_confirmPassword'));
      dataForm.delete('input_password');
      dataForm.delete('input_newPassword');
      dataForm.delete('input_confirmPassword');

      dataForm = new URLSearchParams(dataForm);

      API
        .post(Utility.getUrlAjax() + '/initializePasswordAction', dataForm)
        .then(response => {
          ResponseManagement(response,
            () => {
              toast.success(response.data.message);
              setShowModalState(false);
            },
            () => { }
          );
        })
        .catch(error => {
          console.error(error)
          ErrorManagement(error, () => { });
        })
    }
  }

  const getModalAccount = (typeModal) => {
    let modal = null;
    if (typeModal === 'changeEmail' && showModalState.changeEmail) {
      modal = <ModalAccount typeModal={typeModal} close={() => handleCloseModal(typeModal)} valid={handleClickActionModal} />
    } else if (typeModal === 'changePassword' && showModalState.changePassword) {
      modal = <ModalAccount typeModal={typeModal} close={() => handleCloseModal(typeModal)} valid={handleClickActionModal} />
    }
    return modal;
  }

  const handleOpenModalRGPD = () => {
    setShowModalRgpd(true);
  }

  const handleCloseModalRGPD = () => {
    document.body.classList.remove('modal-fade-in');
    setShowModalRgpd(false);
  }

  const getModalRGPD = () => {
    return (
      <ModalTransition
        size="tiny"
        open={showModalRgpd}
        handleClose={handleCloseModalRGPD}
        header={globalContext.translations.learnMore}
        content={globalContext.translations.infosRGPD}
        actions={
          <Button
            positive
            icon="cancel"
            labelPosition="right"
            content={globalContext.translations.ok}
            onClick={handleCloseModalRGPD}
          />
        }
      />
    )
  }

  const handleChangeCheckboxGdprAgreement = (event) => {
    let checkbox = event.target.closest('.checkbox').querySelector('input[type="checkbox"]');
    setGdprAgreementState(!checkbox.checked);
  }

  /*const handleChangeCheckboxMailing = (event) => {
    let checkbox = event.target.closest('.checkbox').querySelector('input[type="checkbox"]');
    setMailingState(!checkbox.checked);
  }*/

  const getForm = () => {
    return (
      <div>
        <Form id="form-connextion-and-setting">
          <Form.Group widths="equal">
            <Form.Field >
              <label>{globalContext.translations.emailEspaceClient}</label>
              <Input
                labelPosition="right"
                label={
                  <Button
                    primary
                    icon="mail"
                    labelPosition="left"
                    onClick={() => handleClickOpenModal('changeEmail')}
                    content={globalContext.translations.edit}
                  />
                }
                value={globalContext.user.mail}
              />
            </Form.Field>

            <Form.Field >
              <label>{globalContext.translations.password}</label>
              <Input
                labelPosition="right"
                label={
                  <Button
                    primary
                    icon="lock"
                    labelPosition="left"
                    onClick={() => handleClickOpenModal('changePassword')}
                    content={globalContext.translations.edit}
                  />
                }
                type="password"
                value="********"
              />
            </Form.Field>
          </Form.Group>

          <Form.Group widths="equal">
            <Form.Field>
              <label>{globalContext.translations.labelRGPD}</label>
              <List>
                <List.Item>
                  <Checkbox
                    name="input_gdprAgreement"
                    label={globalContext.translations.labelcheckboxRGPD}
                    defaultChecked={gdprAgreementState}
                    readOnly={false}
                    onChange={handleChangeCheckboxGdprAgreement}
                  />
                  &nbsp;
                  <span className="rgpdLink" onClick={handleOpenModalRGPD}>({globalContext.translations.learnMore})</span>
                </List.Item>
                <List.Item>
                  {/*<Checkbox
                    name="input_mailing"
                    label={globalContext.translations.newsLetter}
                    defaultChecked={mailingState}
                    readOnly={false}
                    onChange={handleChangeCheckboxMailing}
                  />*/}
                </List.Item>
              </List>
            </Form.Field>
          </Form.Group>

          <Form.Field className="mt-5">
            <Button
              positive
              className="mx-auto d-block"
              content={globalContext.translations.next}
              icon="right arrow"
              labelPosition="right"
              onClick={handleSubmit}
            />
          </Form.Field>
        </Form>
        {getModalAccount('changeEmail')}
        {getModalAccount('changePassword')}
        {getModalRGPD()}
      </div>
    );
  }

  return (
    <div>
      {dataLoadState ? getForm() : null}
    </div>
  );
}

export default FormConnectionAndSetting;